// extracted by mini-css-extract-plugin
module.exports = {"linkBox":"boxes_linkBox__3Y6B8","relativeBox":"boxes_relativeBox__3JTYR","absoluteBox":"boxes_absoluteBox__fweDZ"};